import { Routes } from '@angular/router';
import { AuthGuard } from './shared/auth.guard';
import { IDTasksComponent } from './admin/proximity-map/id-tasks.component';

// Routing przeniesiony do app.config.ts
export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.routes').then(m => m.LOGIN_ROUTES)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
    canActivate: [AuthGuard]
  },
  {
    path: 'clients',
    loadChildren: () => import('./clients/clients.routes').then(m => m.CLIENTS_ROUTES),
    canActivate: [AuthGuard]
  },
  {
    path: 'appointments',
    loadChildren: () => import('./appointments/appointments.routes').then(m => m.APPOINTMENTS_ROUTES),
    canActivate: [AuthGuard]
  },
  {
    path: 'trichoscopy/:clientId',
    loadChildren: () => import('./trichoscopy/trichoscopy.routes').then(m => m.TRICHOSCOPY_ROUTES),
    canActivate: [AuthGuard]
  },
  {
    path: 'consultations',
    loadChildren: () => import('./consultations/consultations.routes').then(m => m.CONSULTATIONS_ROUTES),
    canActivate: [AuthGuard]
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.routes').then(m => m.REPORTS_ROUTES),
    canActivate: [AuthGuard]
  },
  {
    path: 'tasks', component: IDTasksComponent
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.routes').then(m => m.ADMIN_ROUTES),
  },
  {
    path: 'not-found',
    loadComponent: () => import('./shared/components/not-found/not-found').then(m => m.NotFound)
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'not-found' }
];